import { ElMessage } from 'element-plus';

// Сначала писать сообщение, потом тип
export function showMessage({
  message,
  type = 'primary',
  duration = 5000,
  showClose = true,
}) {
  ElMessage({
    showClose,
    message,
    type,
    duration,
  });
}

export function showErrors(errors) {
  errors.forEach(({ errorMessages }) => {
    errorMessages.forEach((errorMessage) => {
      // фикс, чтобы сообщения не наслаивались друг на друга
      setTimeout(
        () =>
          showMessage({
            type: 'error',
            message: errorMessage,
          }),
        0,
      );
    });
  });
}

// создаем структуру сообщения об ошибке, как на бэкенде
export function createErrorMessage(message) {
  return {
    errors: [
      {
        errorMessages: [message],
      },
    ],
  };
}
